import React from 'react';
import { ButtonViewer } from '../viewer/button-viewer.js';
import 'ricos-context';
import 'ricos-schema';
import 'wix-rich-content-common';
import '../style-inject.es-e7b07dd7.js';
import '../dataHooks.js';
import '../types.js';

const Button = ({ componentData, settings, node }) => {
  return /* @__PURE__ */ React.createElement(
    ButtonViewer,
    {
      nodeId: node.attrs.id,
      buttonData: componentData,
      settings
    }
  );
};

export { Button };
//# sourceMappingURL=component.js.map
